import { render, staticRenderFns } from "./ChoosePage.vue?vue&type=template&id=312e7518"
import script from "./ChoosePage.vue?vue&type=script&lang=js"
export * from "./ChoosePage.vue?vue&type=script&lang=js"
import style0 from "./ChoosePage.vue?vue&type=style&index=0&id=312e7518&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports